import React, {useState} from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import { FileTextOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import commaNumber from "comma-number";
import "../../../components/common/bt.css";

const format = commaNumber.bindWith(",", ".");

const MonthlySalaryReportTable = ({ printMode = false }) => {
  const { list, loading, filters } = useSelector(
    (state) => state.monthlySalaryReport
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };
  // ensure filters exist (fallback)
  const month = filters?.month;
  const year = filters?.year;

  const columns = [
    { title: "No.", render: (_, __, index) => index + 1, width: 60 },
    { title: "Name", dataIndex: "name" },
    { title: "Department", dataIndex: "department" },
    { title: "Designation", dataIndex: "designation" },
    {
      title: "Salary",
      dataIndex: "salary",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    { title: "Attendance", dataIndex: "attendance", align: "right" },
    { title: "Leave With Pay", dataIndex: "leave_with_pay", align: "right" },
    {
      title: "Deduction",
      dataIndex: "deduction",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    {
      title: "Conveyance",
      dataIndex: "conveyance",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    {
      title: "MA",
      dataIndex: "ma",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    {
      title: "TA",
      dataIndex: "ta",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    {
      title: "DA",
      dataIndex: "da",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    {
      title: "Others Commission",
      dataIndex: "others_commission",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    {
      title: "Sales Amount",
      dataIndex: "sales_amount",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    { title: "Commission %", dataIndex: "commission_percent", align: "right",   
      render: (val) => (val === undefined || val === null ? "" : String(val)), },
    {
      title: "Sales Commission",
      dataIndex: "sales_commission",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    {
      title: "Flight Ticket",
      dataIndex: "flight_ticket",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    {
      title: "Paid",
      dataIndex: "paid",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    {
      title: "Payable",
      dataIndex: "payable",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },
    {
      title: "Action",
      key: "action",
      render: (_, row) => (
        <Link to={`/hrpayroll/salary-voucher/${row.id}/${month}/${year}`}>
          <FileTextOutlined style={{ cursor: "pointer", fontSize: 18 }} />
        </Link>
      ),
    },
  ];

  const totals = list.reduce(
    (acc, row) => {
      acc.salary += Number(row.salary) || 0;
      acc.attendance += Number(row.attendance) || 0;
      acc.leave_with_pay += Number(row.leave_with_pay) || 0;
      acc.deduction += Number(row.deduction) || 0;
      acc.conveyance += Number(row.conveyance) || 0;
      acc.ma += Number(row.ma) || 0;
      acc.ta += Number(row.ta) || 0;
      acc.da += Number(row.da) || 0;
      acc.others_commission += Number(row.others_commission) || 0;
      acc.sales_commission += Number(row.sales_commission) || 0;
      acc.sales_amount += Number(row.sales_amount) || 0;
      acc.commission_percent += Number(row.commission_percent) || 0;
      acc.flight_ticket += Number(row.flight_ticket) || 0;
      acc.paid += Number(row.paid) || 0;
      acc.payable += Number(row.payable) || 0;
      return acc;
    },
    {
      salary: 0,
      attendance: 0,
      leave_with_pay: 0,
      deduction: 0,
      conveyance: 0,
      ma: 0,
      ta: 0,
      da: 0,
      others_commission: 0,
      sales_commission: 0,
      sales_amount: 0,
      commission_percent: 0,
      flight_ticket: 0,
      paid: 0,
      payable: 0,
    }
  );

  if (printMode) {
    return (
      <table className="ledger-print-table monthly-salary-print-table">
        <tbody>
          <tr className="ledger-print-heading">
            <td>No.</td>
            <td>Name</td>
            <td>Department</td>
            <td>Designation</td>
            <td style={{ textAlign: "right" }}>Salary</td>
            <td style={{ textAlign: "right" }}>Attendance</td>
            <td style={{ textAlign: "right" }}>LWP</td>
            <td style={{ textAlign: "right" }}>Deduction</td>
            <td style={{ textAlign: "right" }}>Conveyance</td>
            <td style={{ textAlign: "right" }}>MA</td>
            <td style={{ textAlign: "right" }}>TA</td>
            <td style={{ textAlign: "right" }}>DA</td>
            <td style={{ textAlign: "right" }}>Others Comm.</td>
            <td style={{ textAlign: "right" }}>Sales Comm.</td>
            <td style={{ textAlign: "right" }}>Flight Ticket</td>
            <td style={{ textAlign: "right" }}>Paid</td>
            <td style={{ textAlign: "right" }}>Payable</td>
          </tr>

          {list.map((row, index) => (
            <tr key={row.id || index}>
              <td>{index + 1}</td>
              <td>{row.name}</td>
              <td>{row.department}</td>
              <td>{row.designation}</td>

              <td style={{ textAlign: "right" }}>{format(row.salary || 0)}</td>
              <td style={{ textAlign: "right" }}>{row.attendance}</td>
              <td style={{ textAlign: "right" }}>{row.leave_with_pay}</td>
              <td style={{ textAlign: "right" }}>{format(row.deduction || 0)}</td>
              <td style={{ textAlign: "right" }}>{format(row.conveyance || 0)}</td>
              <td style={{ textAlign: "right" }}>{format(row.ma || 0)}</td>
              <td style={{ textAlign: "right" }}>{format(row.ta || 0)}</td>
              <td style={{ textAlign: "right" }}>{format(row.da || 0)}</td>
              <td style={{ textAlign: "right" }}>{format(row.others_commission || 0)}</td>
              <td style={{ textAlign: "right" }}>{format(row.sales_commission || 0)}</td>
              <td style={{ textAlign: "right" }}>{format(row.flight_ticket || 0)}</td>
              <td style={{ textAlign: "right" }}>{format(row.paid || 0)}</td>
              <td style={{ textAlign: "right" }}>{format(row.payable || 0)}</td>
            </tr>
          ))}

          <tr className="ledger-total-row">
            <td colSpan={4} style={{ textAlign: "right" }}>
              Grand Total
            </td>

            <td style={{ textAlign: "right" }}>{format(totals.salary)}</td>
            <td style={{ textAlign: "right" }}>{totals.attendance}</td>
            <td style={{ textAlign: "right" }}>{totals.leave_with_pay}</td>
            <td style={{ textAlign: "right" }}>{format(totals.deduction)}</td>
            <td style={{ textAlign: "right" }}>{format(totals.conveyance)}</td>
            <td style={{ textAlign: "right" }}>{format(totals.ma)}</td>
            <td style={{ textAlign: "right" }}>{format(totals.ta)}</td>
            <td style={{ textAlign: "right" }}>{format(totals.da)}</td>
            <td style={{ textAlign: "right" }}>{format(totals.others_commission)}</td>
            <td style={{ textAlign: "right" }}>{format(totals.sales_commission)}</td>
            <td style={{ textAlign: "right" }}>{format(totals.flight_ticket)}</td>
            <td style={{ textAlign: "right" }}>{format(totals.paid)}</td>
            <td style={{ textAlign: "right" }}>{format(totals.payable)}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={list}
      data-testid="monthly-record-table"
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      scroll={printMode ? undefined : { x: "max-content" }}
      size={printMode ? "small" : "middle"}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={4}>
            <strong>Grand Total</strong>
          </Table.Summary.Cell>

          <Table.Summary.Cell index={4} align="right">
            {format(totals.salary.toFixed(2))}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={5} align="right">
            {totals.attendance}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={6} align="right">
            {totals.leave_with_pay}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={7} align="right">
            {format(totals.deduction.toFixed(2))}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={8} align="right">
            {format(totals.conveyance.toFixed(2))}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={9} align="right">
            {format(totals.ma.toFixed(2))}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={10} align="right">
            {format(totals.ta.toFixed(2))}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={11} align="right">
            {format(totals.da.toFixed(2))}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={12} align="right">
            {format(totals.others_commission.toFixed(2))}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={13} align="right">
            {format(totals.sales_amount.toFixed(2))}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={14} align="right">
            {totals.commission_percent}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={15} align="right">
            {format(totals.sales_commission.toFixed(2))}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={16} align="right">
            {format(totals.flight_ticket.toFixed(2))}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={17} align="right">
            {format(totals.paid.toFixed(2))}
          </Table.Summary.Cell>

          <Table.Summary.Cell index={18} align="right">
            {format(totals.payable.toFixed(2))}
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default MonthlySalaryReportTable;